export const SLOT_SETUP_TYPES = [
  'theater',
  'classroom',
  'standing',
  'banquet',
  'boardroom',
  'u_shape',
  'concert',
  'cocktail',
];

export function setupTypeLabel(setup, t) {
  switch (setup) {
    case 'theater':
      return t('PLANNING.SHOW.SETUP_TYPES.THEATER');
    case 'classroom':
      return t('PLANNING.SHOW.SETUP_TYPES.CLASSROOM');
    case 'standing':
      return t('PLANNING.SHOW.SETUP_TYPES.STANDING');
    case 'banquet':
      return t('PLANNING.SHOW.SETUP_TYPES.BANQUET');
    case 'boardroom':
      return t('PLANNING.SHOW.SETUP_TYPES.BOARDROOM');
    case 'u_shape':
      return t('PLANNING.SHOW.SETUP_TYPES.U_SHAPE');
    case 'concert':
      return t('PLANNING.SHOW.SETUP_TYPES.CONCERT');
    case 'cocktail':
      return t('PLANNING.SHOW.SETUP_TYPES.COCKTAIL');
    default:
      return setup || '';
  }
}

export function setupsForSpace(space) {
  if (!space) return SLOT_SETUP_TYPES;

  const available = SLOT_SETUP_TYPES.filter(value => {
    const capacity = space[value];
    return capacity != null && capacity !== '' && capacity !== 'n/a';
  });

  return available.length ? available : SLOT_SETUP_TYPES;
}

export function buildTimeslotMetadata(
  existingMetadata,
  { setup, pax, color, customAttributes } = {}
) {
  const metadata = { ...(existingMetadata || {}) };

  // Explicit null clears keys via PlanningAllocationsController#merge_allocation_metadata.
  // Omitting the key would keep the previous value on update.
  metadata.setup = setup || null;
  metadata.pax = pax !== null && pax !== undefined && pax !== '' ? pax : null;
  metadata.color = color || null;

  // Full replace when provided; omit the arg to leave existing custom_attributes untouched.
  if (customAttributes !== undefined) {
    const attrs =
      customAttributes && typeof customAttributes === 'object'
        ? { ...customAttributes }
        : {};
    metadata.custom_attributes = Object.keys(attrs).length ? attrs : null;
  }

  return metadata;
}
